'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createAccountTrigger = require('hellosign/components/auth/create-account-trigger');

var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _slack_logo = require('landing-pages/assets/slack_logo.svg');

var _slack_logo2 = _interopRequireDefault(_slack_logo);

var _clouds_slack = require('landing-pages/assets/clouds_slack.svg');

var _clouds_slack2 = _interopRequireDefault(_clouds_slack);

var _overlay_left = require('landing-pages/assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('landing-pages/assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _notifications_icon = require('landing-pages/assets/notifications_icon.svg');

var _notifications_icon2 = _interopRequireDefault(_notifications_icon);

var _daily_reminder_icon = require('landing-pages/assets/daily_reminder_icon.svg');

var _daily_reminder_icon2 = _interopRequireDefault(_daily_reminder_icon);

var _megaphone_icon = require('landing-pages/assets/megaphone_icon.svg');

var _megaphone_icon2 = _interopRequireDefault(_megaphone_icon);

var _screenshot_slack = require('landing-pages/assets/screenshot_slack.gif');

var _screenshot_slack2 = _interopRequireDefault(_screenshot_slack);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

var _ctaButton = require('landing-pages/components/common/cta-button');

var _ctaButton2 = _interopRequireDefault(_ctaButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Slack(p) {
    // Slack constants
    var benefits = [{
        icon: _notifications_icon2['default'],
        title: 'Real time notifications in your channels',
        text: 'Get updated in real time when your documents and contracts are signed, all within your designated Slack channel.'
    }, {
        icon: _daily_reminder_icon2['default'],
        title: 'Daily reminders for unsigned docs',
        text: 'Be reminded of which customers currently have outstanding signature requests. Your team will always know when to follow up.'
    }, {
        icon: _megaphone_icon2['default'],
        title: 'Celebrate your wins',
        text: 'Pin fun reactions to HelloSign updates and celebrate as soon as that important deal closes!'
    }];
    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.hellosign.com%2Fslack&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20now%20integrates%20with%20Slack%3F%20Get%20updates%20on%20your%20docs%20posted%20right%20to%20your%20favorite%20channel.&tw_p=tweetbutton&url=http%3A%2F%2Fwww.hellosign.com%2Fslack%3Futm_source%3Dtwitter%26utm_medium%3Ds2s';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/slack?utm_source=facebook%26utm_medium=s2s';
    var linkedInLink = 'https://www.linkedin.com/cws/share?url=http%3A%2F%2Fwww.hellosign.com%2Fslack%3Futm_source%3Dlinkedin%26utm_medium%3Ds2s&original_referer=https%3A%2F%2Fwww.hellosign.com%2Fslack&token=&isFramed=false&lang=en_US&_ts=1467407448802.2288&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
    var border = '2px solid #D7D7D7';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations' },
        _react2['default'].createElement(IllustrationArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(HowItWorks, p),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/201427097-Slack' }),
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
        )
    );
}

function CTALink(p) {
    var linkURL = '/home/myAccount#integrations';

    // Return standard link if user is already logged in
    if (p.isUserLoggedIn) {
        return _react2['default'].createElement(
            'a',
            { href: linkURL },
            p.linkText
        );
    }

    // Otherwise, create a trigger so we can display the signup modal
    var trigger = _react2['default'].createElement(
        'a',
        null,
        p.linkText
    );
    return _react2['default'].createElement(_createAccountTrigger2['default'], _extends({}, p, {
        trigger: trigger,
        redirectUrl: linkURL,
        homeUrl: linkURL,
        googleOpenIdUrl: p.googleOpenIdLocationUrl,
        header: 'Get Started' }));
}

function HowItWorks(p) {
    var loginTrigger = _react2['default'].createElement(CTALink, _extends({}, p, { linkText: 'add HelloSign to Slack' }));

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-3 large-push-9 columns' },
                _react2['default'].createElement(
                    'p',
                    null,
                    'When you ',
                    loginTrigger,
                    ', all you need to do is connect your accounts and choose if you want to send your notifications to one of your channels, as a direct message to a team member, or to Slackbot.'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'You\u2019ll get notifications when someone views and signs a document and when the document has been signed by everyone. Just click the document name to preview the document and check its progress.'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'All of the documents you send through the extension will show up in the documents view on HelloSign.com.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
                _react2['default'].createElement('img', { src: _screenshot_slack2['default'] })
            )
        )
    );
}

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row', style: { backgroundColor: '#AEDEDA' } },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _slack_logo2['default'], alt: 'Slack Logo', className: 'dropbox-logo', style: { width: 120 } })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Get HelloSign Updates in Your Slack Channels'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'Keep your teams & channels in the know on the status of your eSigned documents with the "Add to Slack" button integration. It\'s free to sign up!'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'signup-button' },
                _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, { buttonText: 'Try it free' }))
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _clouds_slack2['default'], alt: 'cloud left' })
        ),
        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
    );
}

module.exports = Slack;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/slack.jsx
 ** module id = 1635
 ** module chunks = 0
 **/